@if (showCallout) {
  <td-wb-call-out class="td-wb-dashboard-as-start-page-callout"
                  type="secondary"
                  [size]="size()"
                  [layout]="layout()"
                  [dismissible]="true"
                  (close)="noThanks()">
    <td-wb-call-out-header class="td-wb-dashboard-as-start-page-callout__content"
                           aria-level="2">
      <span translate="tdWb.lti.dashboard.startPageCallout.HEADER"></span>
    </td-wb-call-out-header>
    <div class="td-wb-dashboard-as-start-page-callout__content-body">
      <span translate="tdWb.lti.dashboard.startPageCallout.BODY"
            class="td-wb-dashboard-as-start-page-callout__content-text"></span>
      <a tdWbHref="link_preferences">
        <span translate="tdWb.lti.dashboard.startPageCallout.GO_TO_PREFERENCES"></span>
        <td-wb-icon class="td-wb-dashboard-as-start-page-callout__link-icon"
                    size="16"
                    iconId="caret-right--small"
                    [inline]="true" />
      </a>
    </div>
  </td-wb-call-out>
}
